import { PageLayoutDefaultMenuNavigationLinkItem } from "@sis/react-library";
import { RouteObject } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';
import { ConfigurationsPage } from "./configurationsPage/ConfigurationsPage";

const url = "configurations";

// use in same file
// eslint-disable-next-line
export const configurationsRoutes = {
    main: `/${url}`
}

export const ConfigurationsNavigation = (): RouteObject[] => {
    // Configurations only for admins
    return [
        {
            path: configurationsRoutes.main,
            element: <ConfigurationsPage />
        }
    ]
}

export const ConfigurationsMenuItems = (): PageLayoutDefaultMenuNavigationLinkItem[] =>
    [{ icon: <SettingsIcon />, text: 'Configurations', navigateTo: configurationsRoutes.main }]
